module.exports = __webpack_public_path__ + "img/16581295_L.5940619b.png";